import { Box } from '@mui/material';
import { useExtendedIntl } from 'hooks/useExtendedIntl';
import { FunctionComponent, PropsWithChildren, useState } from 'react';
import { SearchInput } from 'shared/SearchInput';

interface TeamsSearchFormProps {
  onSubmit: (value: string) => void;
}

export const TeamsSearchForm: FunctionComponent<PropsWithChildren<TeamsSearchFormProps>> = ({ onSubmit }) => {
  const [inputValue, setInputValue] = useState<string>('');
  const { formatMessage } = useExtendedIntl();

  const handleClear = () => {
    setInputValue('');
    onSubmit('');
  };

  return (
    <Box
      component="form"
      sx={{
        padding: '0 2rem',
        margin: '0 auto',
      }}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(inputValue);
      }}
    >
      <SearchInput
        size="medium"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={formatMessage({ id: 'teams-submenu.search-input' })}
        onClear={handleClear}
      />
    </Box>
  );
};
